export const isAeDomain = (): boolean => {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname.toLowerCase()
    return host.includes('ae.flyin.com') || host.includes('meae.flyin.com')
}

export default isAeDomain
